import type { Locale, TranslationCatalog } from './types';
import { ar } from './ar';
import { en } from './en';
import { es } from './es';
import { zhHans } from './zh-hans';

export type { Locale, PageMeta, TranslationCatalog } from './types';
export { ar } from './ar';
export { en } from './en';
export { es } from './es';
export { zhHans } from './zh-hans';

export const locales = ['en', 'es', 'zh-hans', 'ar'] as const satisfies readonly Locale[];

export const defaultLocale: Locale = 'en';

export const STORAGE_KEY = 'rp.lang';

export const catalogs: Record<Locale, TranslationCatalog> = {
  en,
  es,
  'zh-hans': zhHans,
  ar,
};

export function dirFor(locale: Locale): 'ltr' | 'rtl' {
  return catalogs[locale].dir;
}

// First matching entry wins; es/zh/ar language prefixes select those locales
// and anything else falls back to English, matching the design's detection.
export function detectLocale(navLangs: readonly string[]): Locale {
  for (const raw of navLangs) {
    const lang = raw.toLowerCase();
    if (lang.startsWith('es')) return 'es';
    if (lang.startsWith('zh')) return 'zh-hans';
    if (lang.startsWith('ar')) return 'ar';
    if (lang.startsWith('en')) return 'en';
  }
  return defaultLocale;
}
